module.exports = __webpack_public_path__ + "static/media/logo-camarasaojosebelmonte.bf426d7e.png";